import { AxiosInstance } from "axios";
import Endpoint from "@/utils/endpoint";
import ErrorService from "./erroService";
import AuditLogAuth, { AuditTypes } from "@/types/app/auditLogs";

export default class AuditLogService {


  constructor(private api: AxiosInstance, private endpoint: Endpoint = new Endpoint()) { }

  async getLogAuths(apiSelect: string, auditType: AuditTypes, fromDate: string, toDate: string): Promise<AuditLogAuth[]> {

    try {
      let url = `${this.getEndPoint(apiSelect)}?type=${auditType}`;
      if(toDate.length >= 8)
        url += `&dtEnd=${toDate}`;
      if (fromDate.length >= 8)
        url += `&dtStart=${fromDate}`;
      const { data } = await this.api.get<AuditLogAuth[]>(url);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return [];
    }

  }

  getEndPoint(apiSelect:string){
    //, 'Product', 'Customer', 'Investment'
    switch (apiSelect) {
      case 'Auth': return this.endpoint.authLogAll;        
        break;
      case 'Product': return this.endpoint.productLogAll;
        break;
      case 'Customer': return this.endpoint.customerLogAll;
        break;
      case 'Investment': return this.endpoint.investmentLogAll;
        break;
      default:
        break;
    }
  }
}